import { CustomError } from './customError';

export class RestBadHttpActionParams extends CustomError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(url: string, message: string, error: any = {}) {
        const errorMessage = `Bad RestHttpAction params at ${url}: ${message}`;
        super(errorMessage, error.message || error, error.stack);
    }
}
